<div class="notification">
  <div class="h-full">
    <div class="notification__text">
      <p
        *ngIf="leftText"
        class="col-start-2 col-span-4 tracking-wide justify-self-start font-normal"
        [innerHTML]="leftText"
        (click)="emitLeftClick.emit()"></p>
      <div class="col-start-9 flex items-center justify-self-end cursor-pointer" (click)="emitClick.emit()">
        <p *ngIf="rightText" class="w-max font-medium mr-3">{{ rightText }}</p>
        <svg-icon class="tracking-widest" [key]="iconKey" [size]="iconSize"></svg-icon>
      </div>
    </div>
  </div>
</div>
